import React from 'react';
import {Loader} from '../../../components/Loader/Loader';

class BillingViewLoader extends React.Component {

    render() {
        return (
            <div className="billing-view-loader">
                <Loader
                    theme="dark"
                    center={true}
                    size="big" />
            </div>
        );
    }
}

export default BillingViewLoader;
